// data object keys
export const ADOBE_PAGE_NAME_KEY = "pageName";
export const ADOBE_SERVER_KEY = "server";
export const ADOBE_PRODUCTS_KEY = "products";
export const ADOBE_EVENTS_KEY = "events";

// prop keys
export const ADOBE_SITE_CONTENT_1_KEY = "prop1";
export const ADOBE_SITE_CONTENT_2_KEY = "prop2";
export const ADOBE_TIMESTAMP_KEY = "prop5";
export const ADOBE_COUNTRY_CODE_KEY = "prop7";
export const ADOBE_PAGE_TYPE_PROP_KEY = "prop8";
export const ADOBE_BROWSING_PLATFORM_KEY = "prop9";
export const ADOBE_PREVIOUS_PAGE_NAME_KEY = "prop10";
export const ADOBE_PAGE_URL_KEY = "prop11";
export const ADOBE_SORT_BY_KEY = "prop13";
export const ADOBE_SAVED_ITEM_ACTION_KEY = "prop32";
export const ADOBE_WISHLIST_ACTION_KEY = "prop49";
export const ADOBE_BOARD_ERROR_KEY = "prop52";
export const ADOBE_LOGIN_STATUS_KEY = "prop31";

// eVar keys
export const ADOBE_CUSTOMER_ID_KEY = "eVar10";
export const ADOBE_SAVED_ITEM_COUNT_KEY = "eVar11";
export const ADOBE_PAGE_TYPE_EVAR_KEY = "eVar15";
export const ADOBE_VISITOR_TYPE_KEY = "eVar17";
export const ADOBE_SITE_ID_KEY = "eVar21";
export const ADOBE_PAGE_LOAD_TIME_FIRST_BYTE_KEY = "eVar29";
export const ADOBE_PAGE_LOAD_TIME_DOM_READY_KEY = "eVar30";
export const ADOBE_MERCHANDISING_ATTRIBUTION_CATEGORY_KEY = "eVar60";
export const ADOBE_SALES_ATTRIBUTION_CATEGORY_KEY = "eVar61";
export const ADOBE_BOARD_ID_KEY = "eVar159";
export const ADOBE_SHARE_ID_KEY = "eVar162";
export const ADOBE_SAVED_ITEMS_RECEIVED_DTC_AND_AFS_ITEMS_KEY = "eVar171";
export const ADOBE_SIMILAR_ITEMS_COUNT_KEY = "eVar223";

// listvar keys
export const ADOBE_SIMILAR_ITEMS_IDS_KEY = "list2";

// event keys
export const ADOBE_SC_ADD_EVENT_KEY = "scAdd";
export const ADOBE_SC_OPEN_EVENT_KEY = "scOpen";
export const ADOBE_SAVED_ITEMS_REFINEMENT_EVENT_KEY = "event5";
export const ADOBE_EDIT_SAVED_ITEM_EVENT_KEY = "event25";
export const ADOBE_EDIT_SAVED_ITEM_AFS_EVENT_KEY = "event303";
export const ADOBE_DELETE_SAVED_ITEM_EVENT_KEY = "event26";
export const ADOBE_ADD_SAVED_ITEM_TO_BAG_EVENT_KEY = "event151";
export const ADOBE_BOARD_ERROR_EVENT_KEY = "event173";
export const ADOBE_SIMILAR_ITEMS_PAGE_IMPRESSION_KEY = "event306";
export const ADOBE_SAVE_SIMILAR_ITEM_FOR_LATER_KEY = "event10";
export const ADOBE_SAVED_ITEMS_SHOW_FULFILMENT_INFO_EVENT_KEY = "event286";
export const ADOBE_SAVED_ITEMS_RECEIVED_FULFILMENT_LABELLED_ITEMS_EVENT_KEY =
  "event288";
export const ADOBE_SAVED_ITEMS_RECEIVED_AFS_ITEMS_EVENT_KEY = "event338";
export const ADOBE_SAVED_ITEMS_RECEIVED_RESTOCKING_SOON_EVENT_KEY = "event345";
export const ADOBE_NOTIFY_ME_EVENT_KEY = "event214";
export const ADOBE_BACK_IN_STOCK_IMPRESSION_KEY = "event225";
export const ADOBE_EARLY_ACCESS_PRODUCTS_EVENT_KEY = "event349";

// Google advert keys
export const ADOBE_SAVED_ITEMS_GOOGLE_ADVERT_ON_PAGE = "eVar106";
export const ADOBE_SAVED_ITEMS_GOOGLE_ADVERT_ON_PAGE_EVENT = "event172";

// misc
export const ADOBE_LINK_TYPE_CUSTOM_LINK = "o";
export const ADOBE_PREVIOUS_PAGE_COOKIE_NAME = "gpv_p10";
